<template>
<!-- Este input não transforma para base64 o arquivo recebido -->
   <div class="form-group">
        <label class="text-info" :for="name"> {{ label }}</label>
        <div class="input-group">
            <label class="input-group-btn">
                <span class="btn btn-primary">
                    <i class="fa fa-fw fa-upload"></i>
                    <input type="file" 
                            :name="name"
                            :required="required"
                            @change="loadPhoto($event)" 
                            style="display: none;">
                </span>
            </label>
            <input type="text" 
                    class="form-control"
                    :style="style"
                    :placeholder="placeholder"
                    v-model="photoText"
                    readonly>
        </div>
    </div>
</template>

<script>
export default {
  name: 'InputFileNotBase64',
  props: {
    label: {},
    name: {type: String, default: ''},
    required: {type: Boolean, default: false},
    placeholder: {type: String, default: ''}
  },
  data () {
    return {
      photoText: ''
    }
  },
  methods: {
    loadPhoto (e) {
      this.photoText = e.target.files[0].name
      this.$emit('input', e.target.files[0])
    }
  }
}
</script>


// WEBPACK FOOTER //
// InputFileNotBase64.vue?1537b552